import Swiper, { Autoplay, EffectCreative, Navigation } from "swiper";

document.addEventListener("DOMContentLoaded", () => {
  const sliderKitElems = document.querySelectorAll(".slider-kit");
  sliderKitElems.forEach((sliderKit) => {
    const sliderSwiper = sliderKit?.querySelector(".slider-kit__swiper");
    const paginationBlock = sliderKit?.querySelector(".slider-kit__thumbs");
    const paginations = sliderKit?.querySelectorAll(".thumbs__item");

    if (sliderKit && sliderSwiper && paginations && paginationBlock) {
      const slides = sliderKit.querySelectorAll(".slider-kit__slide");
      const slider = new Swiper(sliderSwiper, {
        modules: [Navigation, Autoplay, EffectCreative],
        loop: true,
        autoplay: {
          delay: 10000,
        },
        effect: "creative",
        speed: 1000,
        parallax: true,
        spaceBetween: 2,
        creativeEffect: {
          prev: {
            translate: ["-20%", 0, -1],
          },
          next: {
            translate: ["100%", 0, 0],
          },
        },
        navigation: {
          nextEl: ".slider-kit .slider-navigation__button--next",
          prevEl: ".slider-kit .slider-navigation__button--prev",
        },
        breakpoints: {
          999: {
            allowTouchMove: false,
          },
          0: {
            allowTouchMove: true,
          },
        },
      });
      slider.autoplay.stop();

      let slideChange;
      let throttle = false;

      const startTimeout = () => {
        clearTimeout(slideChange);
        if (throttle) {
          slider.autoplay.stop();
          slideChange = setTimeout(() => {
            throttle = false;
            slider.slideNext();
            slider.autoplay.start();
          }, 30000);
        }
      };

      slider.on("touchMove", () => (throttle = true));

      let activeIndex = 0;

      const scrollBlock = () => {
        if (window.innerWidth <= 999) {
          paginationBlock.scrollTo({
            left: paginations[activeIndex].offsetLeft - 20,
            behavior: "smooth",
          });
        }
      };

      slider.on("slideChange", () => {
        paginations[activeIndex].classList.remove("thumbs__item--active");
        activeIndex = slider.realIndex;
        const video = slides[activeIndex].querySelector("video");
        if (video) video.currentTime = 0;
        if (innerWidth <= 999) scrollBlock();
        setTimeout(() => {
          startTimeout();
          paginations[activeIndex].classList.add("thumbs__item--active");
        }, 1000);
      });

      paginations.forEach((pagiantion, index) => {
        pagiantion.addEventListener("click", () => {
          throttle = true;
          slider.slideTo(index + 1);
        });
      });

      let animate = false;
      const startAnimate = () => {
        if (animate) return;
        animate = true;
        paginations[activeIndex].classList.add("thumbs__item--active");
        const video = slides[activeIndex].querySelector("video");
        if (video) video.currentTime = 0;
        slider.autoplay.start();
      };
      window.addEventListener("scroll", () => {
        if (window.scrollY > sliderKit.offsetTop + sliderKit.clientHeight) return;
        if (window.scrollY >= sliderKit.offsetTop - sliderSwiper.clientHeight / 2) {
          startAnimate();
        }
      });

      window.addEventListener("resize", () => {
        slider.update();
      });
    }
  });
});
